export const text = '#323232';
export const hoverr = '#E50019';
export const black = '#221F1F';
export const transition = '.6s cubic-bezier(0.4, 0, 0, 1)';
export const secondary_color = '#98223C';
export const title = `"Founders Grotesk",Barlow", Euclid Square, Arial, Helvetica, freesans, sans-serif `